import { customPaymentMethods } from "@jti/fe-common";
import type { MagentoPaymentMethod } from "@jti/magento-types";

export const isPayOnDeliveryEnabled = (paymentMethods: MagentoPaymentMethod[] | undefined | null): boolean => {
  if (!paymentMethods) {
    return false;
  }

  return paymentMethods.some(({ code }) => code === customPaymentMethods.payOnDelivery);
};
